import React from 'react';

import Spinner from 'components/Spinner';
import ListItemContainer from 'modules/Media/components/ListItem/Container';
import PreviewBody from 'modules/Media/components/ListItem/previewBody';
import ActionsContainer from 'modules/Media/components/ListItem/actionsContainer';
import TagsContainer from 'modules/Media/components/ListItem/tagsContainer';

// it's can't be imported on ActionsContainer, not working on .tsx
import DownloadIcon from 'assets/images/icons_svg/download.svg';
import ResizeIcon from 'assets/images/icons_svg/resize.svg';
import ShareIcon from 'assets/images/icons_svg/share.svg';
import StarIcon from 'assets/images/icons_svg/star.svg';
import StarOrangeIcon from 'assets/images/icons_svg/star_orange.svg';
import MainArticle from '../UserArticles/MainArticle';

class ListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLocallyViewed: false, isLoading: false };
    this.setLoading = this.setLoading.bind(this);
  }

  setLoading(loading) {
    this.setState({ loading });
  }

  render() {
    const { id, content, selected, tags } = this.props;
    const { is_read, is_favorite } = this.props;
    const { toggleRead, toggleFavorite } = this.props;
    const { handleTagsModal, handleTagsSubmit, onShareClick } = this.props;

    return (
      <ListItemContainer selected={selected}>
        <Spinner loading={this.state.isLoading} />
        <div className="articleContent">
          <MainArticle article={this.props} showBody={false} />
        </div>
        <div className="articleContentContainer">
          <div className="contentText">
            <PreviewBody
              id={id}
              content={content}
              is_read={is_read}
              toggleRead={toggleRead}
            />
            <TagsContainer
              id={id}
              tags={tags}
              handleTagsModal={handleTagsModal}
              handleTagsSubmit={handleTagsSubmit}
            />
          </div>
        </div>
        <div className="rightArticleItem">
          <div className="rightArticleItemContent">
            <ActionsContainer
              id={id}
              content={content}
              is_read={is_read}
              is_favorite={is_favorite}
              onReadClick={toggleRead}
              onShareClick={onShareClick}
              toggleFavorite={toggleFavorite}
              handleLoading={this.setLoading}
              downloadIcon={DownloadIcon}
              openOusideIcon={ResizeIcon}
              shareIcon={ShareIcon}
              favoriteIcon={StarOrangeIcon}
              nofavoriteIcon={StarIcon}
            />
          </div>
        </div>
      </ListItemContainer>
    );
  }
}

export default ListItem;
